module.exports = __webpack_public_path__ + "static/media/arrow-down-yellow.b24285c2.svg";